import { render, staticRenderFns } from "./SlideUpComponent.vue?vue&type=template&id=65f4aad0&scoped=true&"
import script from "./SlideUpComponent.vue?vue&type=script&lang=js&"
export * from "./SlideUpComponent.vue?vue&type=script&lang=js&"
import style0 from "./SlideUpComponent.vue?vue&type=style&index=0&id=65f4aad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f4aad0",
  null
  
)

export default component.exports